import { Add } from "@mui/icons-material";
import { useQuery } from "@tanstack/react-query";
import DefaultFilter, { ISelectItem } from "app/components/filter/defaultFilter";
import DefaultMenu, { IMenuItemProps } from "app/components/menu/DefaultMenu";
import Search from "app/components/search/Search";
import { PageContentContainer } from "app/components/styles";
import TableHeader from "app/components/table/tableHeader/TableHeader";
import { TCategoryBody, TCategoryFilterRequest } from "core/models/category";
import { ITableHeadCell, Order } from "core/models/table";
import { fecthCategory } from "core/querryes/category/categoryQuerry";
import theme from "core/theme/theme";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import MoreHorizRounded from "@mui/icons-material/MoreHorizRounded";
import DataTable from "app/components/table/table/table";
import DataTablePagination from "app/components/table/pagination/pagination";
import { ContentBody } from "app/styles";
import EditCategoryModal from "../editers/editCategory";
import NewDefaultFilter from "app/components/filter/newDefaultFilter";
import { CategoryService } from "core/api/category/categoryService";

const head: ITableHeadCell[] = [
    { name: "name", label: "Nome", align: "left" },
    { name: "description", label: "Descrição", align: "left" },
    { name: "createdAt", label: "Criado em", align: "left" },
    { name: "active", label: "Ativo", align: "left" },
    { name: "actions2", label: "Opções", align: "left" },
];

const filterItems: ISelectItem[] = [
    { name: "Nome", value: "name", type: "texto" },
];

function Category() {
    const navigate = useNavigate();

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(0);
    const [order, setOrder] = useState<Order>("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [filterModal, setFilterModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [idCategory, setIdCategory] = useState<string | undefined>();
    const [categoryFilters, setCategoryFilters] = useState<TCategoryFilterRequest>({
        name: "",
    });
    const [isOpen, setIsOpen] = useState(false);
    const [tempCategory, setTempCategory] = useState<TCategoryBody | undefined>()

    const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleAccessRowById = (id: string) => {
        setIdCategory(id);
        setTempCategory(data?.content.find((category: any) => category.id === id))
    }




    const [searchParams, setSearchParams] = useSearchParams()
    const name = searchParams.get('name') || ''

    const { data, isLoading, isSuccess, refetch } = useQuery({
        queryKey: ["category", page, rowsPerPage, orderBy, order, name],
        queryFn: () =>
            fecthCategory(
                page,
                rowsPerPage,
                orderBy,
                order,
                name,
            ),
    })

    const menuItems: IMenuItemProps[] = [
        {
            function: () => {
                setIsOpen(true);
                handleCloseMenu();
            },
            label: "Editar categoria",
        },
        {
            function: async () => {
                await CategoryService.activeInativeCategory(
                    String(tempCategory?.id)
                ).then((resp) => {
                    refetch()
                    handleCloseMenu()
                })

            },
            label: tempCategory?.active ? 'Inativar categoria' : 'Ativar categoria'
        }
    ];

    const handleNameChange = (value: string | undefined) => {
        const newParams = new URLSearchParams(searchParams)
        if (value) {
            newParams.set('name', value ?? '')
        } else {
            newParams.delete('name')
        }
        setSearchParams(newParams)
    }

    useEffect(() => {
        if (isSuccess && data) {
            setCount(data.totalElements);
        }
    }, [isSuccess, data]);

    const selectedCategory = data?.content.find((category: any) => category.id === idCategory);
    return (
        <PageContentContainer>
            <TableHeader
                filterBtn
                filterBtnAction={() => setFilterModal(true)}
                mainActionFunction={() => navigate("/registrarCategoria")}
                mainActionLabel="Cadastrar categoria"
                mainIcon={<Add sx={{ color: theme.COLORS.YELLOW2 }} />}
                extraComponents={
                    <Search
                        searchPlaceHolder="Nome da categoria..."
                        type="text"
                        querrySearching={isLoading}
                        querry={name}
                        onChange={handleNameChange}
                    />
                }
            />
            <ContentBody>
                <DataTable
                    head={head}
                    data={data?.content}
                    order={order}
                    orderBy={orderBy}
                    setOrder={setOrder}
                    setOrderBy={setOrderBy}
                    isLoading={isLoading}
                    accessRowById={handleAccessRowById}
                    menu={
                        <Tooltip title="Opções">
                            <IconButton onClick={handleClickMenu}>
                                <MoreHorizRounded />
                            </IconButton>
                        </Tooltip>
                    }
                />
                <DefaultMenu
                    anchor={anchorEl}
                    menuItems={menuItems}
                    onClose={handleCloseMenu}
                    status={open}
                />
                <DataTablePagination
                    setPage={setPage}
                    page={page}
                    setRowsPerPage={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    count={count}
                />
                <NewDefaultFilter
                    isOpen={filterModal}
                    items={filterItems}
                    onClose={() => setFilterModal(false)}
                    onOpen={() => setFilterModal(true)}
                    title="Filtrar Vendas"
                    changePage={setPage}
                />
                {selectedCategory && isOpen &&
                    <EditCategoryModal
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        onClose={() => setIsOpen(false)}
                        onOpen={() => setIsOpen(true)}
                        category={selectedCategory}
                        refetch={refetch}
                    />}
            </ContentBody>
        </PageContentContainer>
    );
};

export default Category